/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update reporting code request
 */
export interface UpdateReportingCodeRequest {
  reportingCodeId: number;
  description: string;
  slackChannel?: string;
}
